
export interface IOptions
{
	safe?: boolean,
	skip?,
	greedyTable?: boolean | number,
}
